export enum Role {
  Admin = 'admin',
  Client = 'client',
  Guest = 'guest',
}
